//@flow
import React from "react";

export function CTAPrint() {
  return (
    <a
      onClick={() => {
        window.print();
      }}
      className="page-action-cta wishlist-main__page-action-cta"
    >
      <span className="page-action-cta__icon">
        <i className="zmdi zmdi-print" />
      </span>
      <span className="page-action-cta__text">Print</span>
    </a>
  );
}
